<template>
  <div>
    <message-form
      v-if="showView"
      message-type="replyAll"
      :predefined-subject="subject"
      :predefined-body="body"
      :predefined-to="to"
      :predefined-from="from"
      @route-change="routeName => $emit('route-change', routeName)"
    />
    <div class="adjoined-body">
      {{ body }}
    </div>
  </div>
</template>

<script>
import MessageForm from '@/components/forms/MessageForm'
import { format } from 'date-fns'

export default {
  name: 'ReplyAll',

  components: {
    MessageForm
  },

  props: {
    messageId: {
      type: String,
      default: '',
      required: true
    },

    mailboxType: {
      type: String,
      default: '',
      required: true
    },

    setCursorInBody: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      subject: '',
      body: '',
      to: [],
      from: {},
      sentDate: '',
      showView: false
    }
  },

  async created () {
    this.$store.dispatch('findAndSetHelpObject', {
      id: 68,
      isInitial: true
    })

    try {
      const { subject, body, to, from, date } = await this.$store.dispatch('messages/getMessage', {
        messageId: this.messageId,
        mailboxType: this.mailboxType,
        setCursorInBody: this.setCursorInBody
      })

      this.to = to
      this.from = from
      this.sentDate = date
      this.subject = subject.includes('RE: ') ? `${subject}` : `RE: ${subject}`

      this.body = `

     ------------------
     On ${format(new Date(date), 'PPPPp')}, ${from.firstName} ${from.lastName} <${from.email}> wrote:

      ${body}`.replace(/  +/g, '')

      this.showView = true
    } catch (error) {
      this.$store.commit('snackbar/update',
        {
          type: 'error',
          message: 'Failed to get message'
        }
      )

      this.$store.dispatch('logError', {
        error,
        fileName: 'Messages > ReplyAll',
        functionName: 'created'
      })
    }
  }
}
</script>
